namespace GeniuzPOS.PriceChange {
    export class ApprovePriceChangeColumns {
        static columnsKey = 'PriceChange.ApprovePriceChange';
    }
}
